function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 13.792,
  cy: 3.082,
  r: 3.082
}), /*#__PURE__*/React.createElement("circle", {
  cx: 13.792,
  cy: 24.501,
  r: 1.849
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6.219,
  cy: 6.218,
  r: 2.774
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21.365,
  cy: 21.363,
  r: 1.541
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.082,
  cy: 13.792,
  r: 2.465
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24.501,
  cy: 13.791,
  r: 1.232
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.694,19.84c-0.843,0.843-0.843,2.207,0,3.05c0.842,0.843,2.208,0.843,3.05,0c0.843-0.843,0.843-2.207,0-3.05 C6.902,18.996,5.537,18.988,4.694,19.84z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21.364,
  cy: 6.218,
  r: 0.924
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "26.349px",
    height: "26.35px",
    viewBox: "0 0 26.349 26.35",
    style: {
      enableBackground: "new 0 0 26.349 26.35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.07c4806f.svg";
export { ForwardRef as ReactComponent };